<template>
  <div class="team-detail-team-status">
    {{ statusString }}
    <ym-img class="team-detail-team-status-icon"
            :src="require(`@/assets/img/group_buy/icon_${status}.png`)"
            :alt="statusString"
    />
  </div>
</template>

<script>
  import { commonLog } from '@/services/app';

  export default {
    name: 'TeamDetailTeamStatus',
    props: {
      status: {
        type: String,
        required: true,
      },
    },
    computed: {
      statusString() {
        const { status } = this;
        switch (status) {
          case 'success':
            return '拼团成功';
          case 'full':
            return '该团已满，无法加入';
          case 'fail':
            return '拼团失败';
          default: {
            commonLog('teamStatusError', status);
            return '';
          }
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .team-detail-team-status {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: @font-size-large;
    color: @color-text-base;
    font-weight: @font-weight-primary;
    margin: 0 auto @size-base;

    &-icon {
      flex-shrink: 0;
      margin-left: @size-small;
      width: 50px;
      height: 50px;
    }
  }
</style>
